import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { authSelectors } from '../../redux/auth';
/**
 * - Если маршрут ограниченный, и пользователь залогинен, рендерит редирект на /tasks
 * - В противном случае рендерит компонент
 */

 interface Props {
  children: React.ReactNode,
  path: string,
  redirectTo?: string,
  restricted?: boolean,
  exact?: boolean,
}

const PublicRoute = ({ redirectTo, children, ...routeProps }: Props) => {
  const isAuthenticated: boolean = useSelector(authSelectors.getIsAuthenticated);
  return (
    <Route {...routeProps}>
      {isAuthenticated ? (
       redirectTo && <Redirect to={redirectTo} />
      ) : (
        children
      )}
    </Route>
  );
};

export default PublicRoute;
